import styled, { css } from "styled-components";
import buildColor from "../../_static/ColorPalette";
import rainLayerUrl from "../../_static/images/rma-blue-texture.png";

export const OuterContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("blue", "900")};

  @media only screen and (min-width: 768px) {
    padding-top: 50px;

    #onfido-mount {
      margin-top: 70px;
    }

    &::before {
      content: "";
      background-image: url(${rainLayerUrl});
      background-repeat: no-repeat;
      background-position-x: center;
      background-size: 1280px auto;
      top: 0;
      left: 0;
      bottom: 450px;
      right: 0;
      position: absolute;
      z-index: 0;
    }
  }

  @media only screen and (max-width: 767px) {
    #onfido-mount .onfido-sdk-ui-Modal-inner {
      padding-bottom: calc(env(safe-area-inset-bottom) + 60px);
      padding-bottom: calc(constant(safe-area-inset-bottom) + 60px);
    }
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  ${({ device }) =>
    device === "mobile"
      ? css`
          margin: 12px 0;
        `
      : css`
          margin-top: 24px;
        `}
`;
